import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerRegister from "./pages/CustomerRegister";
import AdminDashboard from "./pages/AdminDashboard";
import AdminCallsByStatus from "./pages/AdminCallsByStatus";
import AddCall from "./pages/AddCall";
import EditCall from "./pages/EditCall";
import ManageCustomers from "./pages/ManageCustomers";
import CustomerDashboard from "./pages/CustomerDashboard";
import CustomerTradeDetails from "./pages/CustomerTradeDetails";

import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ProtectedCustomerRoute from "./components/ProtectedCustomerRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route path="/customer-register" element={<CustomerRegister />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedAdminRoute>
              <AdminDashboard />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/admin-calls/:status"
          element={
            <ProtectedAdminRoute>
              <AdminCallsByStatus />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/add-call"
          element={
            <ProtectedAdminRoute>
              <AddCall />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/edit-call"
          element={
            <ProtectedAdminRoute>
              <EditCall />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/manage-customers"
          element={
            <ProtectedAdminRoute>
              <ManageCustomers />
            </ProtectedAdminRoute>
          }
        />

        <Route
          path="/customer-trades/:customerId"
          element={
            <ProtectedAdminRoute>
              <CustomerTradeDetails />
            </ProtectedAdminRoute>
          }
        />

        {/* Protected Customer Routes */}
        <Route
          path="/customer-dashboard"
          element={
            <ProtectedCustomerRoute>
              <CustomerDashboard />
            </ProtectedCustomerRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;